import '@/styles/styles.scss';
import app from '@/scripts/app';

window.addEventListener('DOMContentLoaded', () => {
  app.$mount('#app');
});
